import { ColumnSort, TableFilters } from '../components/shared/table/types';
import { api } from './services';

type UploadDocumentsRequest = FormData;

export const fetchMLTestDocuments = async (reqBody: { pageNumber: number; pageSize: number; filters: TableFilters; columnSort: ColumnSort | undefined }) => await api('document/mlTest/getAll', { ...reqBody }, 'post');
export const uploadMLTestDocuments = async (reqBody: UploadDocumentsRequest) => await api('document/mlTest/upload', reqBody, 'post', {}, true);
export const openMLTestDocument = async (reqBody: { location: string }) => await api('document/mlTest/open', { ...reqBody }, 'post', {}, false, true);
export const getMLTestDocumentById = async (reqBody: { mlTestDocumentId: number }) => await api('document/mlTest/getById', { ...reqBody }, 'post');
